module.exports = __webpack_public_path__ + "fromBrideToMother-we-b.da8ea631.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/fromBrideToMother-we-b.jpg
// module id = app9
// module chunks = 0